module.exports = __webpack_public_path__ + "8e300b15cd48908aeaebb00ea1ad10d9.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/profiles/profile/basic/basic.html
// module id = 2520
// module chunks = 0